/* eslint-disable @typescript-eslint/default-param-last */
/* eslint no-param-reassign: ["error", { "props": false }] */
import dayjs from 'dayjs';
import produce, { Draft } from 'immer';
import { GraphFilterState, GraphsFilterCustomAction, Interval } from '../types';
import { SET_SELECTED_INTERVAL, SET_INTERVAL, RESET_GRAPH_FILTERS } from '../actions/graphsFilterActions';

const formatInterval = (interval: Interval) => {
  const startDate = dayjs(interval.startDate);
  const endDate = dayjs(interval.endDate);
  return {
    startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
    endDate: endDate.format('YYYY-MM-DDTHH:mm:ss'),
  };
};

const getDefaultInterval = () => '2-weeks';

const initialState: GraphFilterState = {
  interval: null,
  selectedInterval: getDefaultInterval(),
};

const dateFilterReducer = (
  state = initialState,
  action: GraphsFilterCustomAction,
): GraphFilterState => {
  switch (action.type) {
    case SET_INTERVAL: {
      return produce(state, (draft: Draft<GraphFilterState>) => {
        draft.interval = formatInterval(action.payload as Interval);
      });
    }
    case SET_SELECTED_INTERVAL: {
      return produce(state, (draft: Draft<GraphFilterState>) => {
        draft.selectedInterval = action.payload as string;
      });
    }
    case RESET_GRAPH_FILTERS: {
      return produce(state, (draft: Draft<GraphFilterState>) => {
        draft.interval = null;
        draft.selectedInterval = getDefaultInterval();
      });
    }

    default:
      return state;
  }
};

export default dateFilterReducer;
